import { FormFieldResponseDTO } from '@/api/base/DTOs';
import { IFormBase, IFormDate } from '@/forms/typings';
import { DateFormFieldBuilder } from '@/forms/builders';
import { adaptFormFieldResponseToValue } from '../utilities/formFieldResponseToValue.adapter';
import { formApiAdapterRegistry } from '../registry/form-api-adapter.registry';

/**
 * Adapts a FormFieldResponseDTO to a DateFormField
 * Handles date picker field types
 */
export const adaptFormFieldResponseToDateFormField = (
  formFieldResponse: FormFieldResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): IFormDate => {
  let dateFormField = new DateFormFieldBuilder()
    .fieldId(formFieldResponse.fieldID)
    .name(formFieldResponse.fieldID)
    .label(formFieldResponse.label ?? formFieldResponse.name)
    .readonly(formFieldResponse.readonly || !formFieldResponse.isEditable)
    .value(adaptFormFieldResponseToValue(formFieldResponse))
    .hasAnyValue(formFieldResponse.hasAnyValue)
    .notApplicable(formFieldResponse.notApplicable)
    .showNotApplicable(formFieldResponse.showNotApplicable)
    .size(formFieldResponse.itemSize);

  if (formFieldResponse.hint) {
    dateFormField = dateFormField.hint(formFieldResponse.hint);
  }

  if (formFieldResponse.hintImageUrl) {
    dateFormField = dateFormField.hintImageUrl(formFieldResponse.hintImageUrl);
  }

  const dateFieldValidations =
    formApiAdapterRegistry.adaptGeneric(
      formFieldResponse.restriction,
    ) as IFormDate['validations'];

  if (dateFieldValidations) {
    dateFormField = dateFormField.validations(dateFieldValidations);
  }

  return dateFormField.parentFieldId(parentFieldId).build();
};
